import { isEmpty } from 'lodash';
export const contracts = (state) => state.contracts;
export const contractReimbursements = (state) => state.contractReimbursements;
export const originalContracts = (state) => state.originalContracts;
export const beforeChangeContracts = (state) => state.beforeChangeContracts;
export const responseData = (state) => state.responseData;
export const medicalSelectionResponse = (state) => state.medicalSelectionResponse;

export const hasContracts = (state) => !isEmpty(state.contracts);
export const isLoadingContracts = (state) => state.isLoadingContracts;
export const isLoadingContractReimbursements = (state) => state.isLoadingContractReimbursements;
export const isLoadingValidateContract = (state) => state.isLoadingValidateContract;
export const isSavingContracts = (state) => state.isSavingContracts;
export const isSavingContractsSuccesfull = (state) => state.isSavingContractsSuccesfull;
export const unselectedRequiredPackages = (state) => state.unselectedRequiredPackages;
export const showUnselectedRequiredPackages = (state) => state.showUnselectedRequiredPackages;

export const requestedContractsAreForNewlyInsuredPersons = (state) => state.requestedContractsAreForNewlyInsuredPersons;

export const getAllCards = (state) => {
  let result = [];
  if (state.contracts) {
    result = getCardByCardGroup(state.contracts.allCards);
  }

  return result;
};

function getCardByCardGroup(cards) {
  const docs = [];
  cards.forEach((card) => {
    if (card.productComponentCode && !docs.map((doc) => doc.code).includes(Number(card.productComponentCode))) {
      docs.push({
        code: Number(card.productComponentCode),
        productType: card.packageTypeForWebApplications.productType,
        productName: card.title,
      });
    }
  });

  return docs;
}
